module.exports = __webpack_public_path__ + "img/client-search-with-sircle-transparent.cd84a7ee.png";